import i18n from '@/i18n/index';
import * as Sentry from '@sentry/vue';

import { useToast } from 'primevue/usetoast';

export default {
  methods: {
    toast_update_succeeded(itemName) {
      const message = itemName
        ? i18n.global.t('toast.update.succeeded', { itemName })
        : i18n.global.t('toast.update.successfully_saved');
      this.toast_open(message, 'is-success');
    },

    toast_create_succeeded(itemName) {
      const message = i18n.global.t('toast.create.succeeded', { itemName });
      this.toast_open(message, 'is-success');
    },

    toast_delete_succeeded(itemName) {
      const message = itemName
        ? i18n.global.t('toast.delete.succeeded', { itemName })
        : i18n.global.t('toast.delete.succeeded_default');
      this.toast_open(message, 'is-success');
    },

    toast_action_succeeded() {
      const message = i18n.global.t('toast.action.succeeded');
      this.toast_open(message, 'is-success');
    },

    toast_action_failed(error) {
      if (error && error.handled_globally) return;
      const message = typeof error === 'string' ? error : i18n.global.t('toast.action.failed');
      this.toast_open(message, 'is-warning');
      if (error instanceof Error) {
        Sentry.captureException(error);
      }
    },

    toast_upload_succeeded() {
      const message = i18n.global.t('toast.upload.succeeded');
      this.toast_open(message, 'is-success');
    },

    // custom success toast
    toast_success(message) {
      this.toast_open(message, 'is-success');
    },

    // custom fail toast
    toast_fail(message) {
      this.toast_open(message, 'is-warning');
    },

    toast_open(message, type) {
      this.$buefy.toast.open({ message, type, duration: type === 'is-success' ? 3000 : 6000 });
    },
  },
};

export const useToasts = () => {
  const toast = useToast();

  const toast_action_failed = ({ message = i18n.global.t('toast.action.failed'), error } = {}) => {
    if (error && error.handled_globally) return;
    toast.add({
      position: 'top-right',
      severity: 'warn',
      summary: message,
      life: 3000,
    });
    if (error instanceof Error) {
      Sentry.captureException(error);
    }
  };

  const toast_action_succeeded = (message = i18n.global.t('toast.action.succeeded')) => {
    toast.add({
      severity: 'success',
      summary: message,
      life: 3000,
    });
  };

  return {
    toast_action_failed,
    toast_action_succeeded,
  };
};
